(function($){
  $doc = $(document);
  mapboxgl.accessToken = 'pk.eyJ1Ijoid2FzaGluZ3Rvbi13YXRlci10cnVzdCIsImEiOiJja2s0YXc3b3owdmdzMnVsNGt5eGFra3U1In0.3Z2ye1I6d3m3PgciaUqo3Q';
  var geocode_api_url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/';
  var maps = {};
 
  var marker_svg = '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="34" viewBox="0 0 26 34"><path fill="#3B836D" fill-rule="evenodd" d="M2.075 19.667l.065.093c.079.116.162.23.245.354l9.411 13.269c.275.387.725.617 1.206.617s.931-.23 1.206-.617l9.389-13.259c.09-.125.176-.245.264-.354l.058-.085v-.001a12.567 12.567 0 001.952-8.72 12.695 12.695 0 00-4.349-7.84A13.145 13.145 0 0013.001 0a13.143 13.143 0 00-8.522 3.123 12.69 12.69 0 00-4.35 7.842 12.568 12.568 0 001.954 8.719l-.008-.017zM13.5 7a5.5 5.5 0 11-.002 11A5.5 5.5 0 0113.5 7z"/></svg>';
  var small_marker = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="31" viewBox="0 0 25 31"><path fill="#3B836D" fill-rule="evenodd" stroke="#FFF" stroke-width="1.5" d="M4.368 4.397a11.431 11.431 0 0116.264 0c4.49 4.53 4.49 11.873 0 16.402L12.5 29l-8.132-8.201c-4.49-4.53-4.49-11.873 0-16.402z"/></svg>';

  var project_popup_html = "<div class='marker-popup'><h2 class='mb-0 font-weight-semibold'>{{{title}}}</h2><div class='project-meta'>{{#if project.location}}<h6 class='h6 font-condensed text-uppercase d-inline-block project-meta-detail'>{{project.location.name}}</h6>{{/if}}</div>{{#if project.image }}<img src='{{project.image}}' class='d-none d-md-block img-fluid mb-3'/>{{/if}}<div {{#if project.permalink}}class='pb-5 pb-md-0 mb-5 mb-lg-3'{{/if}}>{{{project.description}}}</div><h6 class='h5 font-condensed font-weight-semibold text-uppercase d-none d-md-block'>Our Approach</h6><ul class='list-unstyled row pb-5 d-none d-md-flex'>{{#each project.all-approaches}}<li class='col-6 text-left text-md-center approach-item {{@key}} {{#if (hasOwn ../project.approaches @key)}}active{{/if}}'><span class='approach-ico {{@key}} d-none d-md-block mx-auto'></span><div class='approach-body'>{{this}}</div></li>{{/each}}</ul>{{#if project.permalink}}<div class='learn-more-wrapper'><a class='btn btn-primary btn-block has-waves has-arrow text-uppercase font-weight-semibold mb-3' href='{{project.permalink}}'><span class='btn-text'>Learn More About this River</span><span class='btn-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='35' height='21' viewBox='0 0 35 21'><path fill='#1A2B3A' fill-rule='evenodd' stroke='#1A2B3A' stroke-width='.5' d='M25.351 1.163a.551.551 0 00-.756-.024.552.552 0 00-.025.75l7.667 8.082H1.532A.531.531 0 001 10.5c0 .29.24.528.532.528h30.705l-7.667 8.082a.548.548 0 00.025.75c.203.19.534.194.756-.025l8.517-8.972a.563.563 0 000-.726L25.35 1.163z'/></svg></span><span class='btn-waves'></span></a></div>{{/if}}</div>";

  // compile the template
  var popup_template = Handlebars.compile(project_popup_html);

  Handlebars.registerHelper("hasOwn", function(context, key) {
    // console.log(context);
    var key = Handlebars.escapeExpression(key);
    // console.log(key);
    // console.log(context.hasOwnProperty(key));
   return context.hasOwnProperty(key);
  });

  var map_center = [-123.14234054840988, 48.028348843859526];

  var selected_point = null;
  var selected_address = null;
  var marker = null;
  var mitigation_avail = false;
  var outdoor_mitigation_avail = false;
  var parcel = null;
  var hoveredWRIA = null;

  var mitigation_content = {
    'unselected': 'Please select a point on the map, or use the search above.',
    'unavailable': '',
    'available': '',
    'available_no_outdoor': '',
  };

  $doc.ready(function(){

    $.getJSON('/wp-json/acf/v3/options/options/', function(data){
      var acf = data.acf;
      mitigation_content['unavailable'] = acf['mitigation_unavailable_content'];
      mitigation_content['available'] = acf['mitigation_available_content'];
      mitigation_content['available_no_outdoor'] = acf['mitigation_available_no_outdoor_content'];
    });

    $('.map-container').each(function(idx){
      var t = $(this);
      // get the ID
      var id = t.attr('id');
      if(!id){
        id = 'mapbox-map-' + (idx + 1);
        t.attr('id', id);
      }

      // initialize the location map
      var map = new mapboxgl.Map({
        container: id,
        style: 'mapbox://styles/washington-water-trust/ckk4b7ejt58lp18qqzyswo8p8',
        interactive: false,
        zoom: 10,
      });

      // store the map for later use
      maps[id] = map;

      // Get the address
      var address = t.data('address');
      geocodeAddress(address, map);
    });

    if($('#mitigation-map').length){
      // initialize the project map
      var map = new mapboxgl.Map({
        container: 'mitigation-map',
        style: 'mapbox://styles/washington-water-trust/cknaycirz0b2g17jg816dy0c4',
        zoom: 10,
        minZoom: 10,
        center: map_center,
        scrollZoom: false,
      });

      // Add zoom and rotation controls to the map.
      map.addControl(new mapboxgl.NavigationControl());

      // add WRIA layers
      map.on('load', function(){
        map.addSource('parcels', {
          type: 'vector',
          url: 'mapbox://washington-water-trust.8v5egegp',
        });
        map.addSource('wr-boundary', {
          type: 'vector',
          url: 'mapbox://washington-water-trust.09sspb0f'
        });
        map.addSource('wr-available', {
          type: 'vector',
          url: 'mapbox://washington-water-trust.6dx4p3hs'
        });

        show_point_results();

        map.addLayer({
          id: 'parcel-layer',
          type: 'fill',
          source: 'parcels',
          'source-layer': 'parcel-7xjmea',
          'paint': {
            'fill-color': '#000',
            'fill-opacity': 0,
            'fill-outline-color': '#000',
          }
        }, 'contour-label');
        map.addLayer({
          id: 'parcel-line-layer',
          type: 'line',
          source: 'parcels',
          'source-layer': 'parcel-7xjmea',
          'paint': {
            'line-color': '#000',
            'line-opacity': [
              'interpolate',
              ['exponential', 0.5],
              ['zoom'],
              10,
              0,
              15,
              0.1
            ]
          }
        }, 'contour-label');
        map.addLayer({
          id: 'wr-fill-layer',
          type: 'fill',
          source: 'wr-available',
          'source-layer': 'WaterRuleAvail-c8sp27',
          'paint': {
            'fill-color': [
              'case',
              ["==", ['get', 'AVAILABLE'], 'Y'],
              '#5DD39E',
              '#F6D81F',
            ],
            'fill-opacity': 0.3,
            'fill-outline-color': [
              'case',
              ["==", ['get', 'AVAILABLE'], 'Y'],
              '#5DD39E',
              '#F6D81F',
            ],
          }
        }, 'contour-label');
        // map.addLayer({
        //   id: 'wria-line-layer',
        //   type: 'line',
        //   source: 'wrias',
        //   'source-layer': 'Upper_Yakima_Basin-c43ed1',
        //   'paint': {
        //     'line-color': '#ffffff',
        //     'line-opacity': [
        //       'case',
        //       ['boolean', ['feature-state', 'hover'], false],
        //       1,
        //       0.5,
        //     ],
        //     'line-width': 1.5,
        //   }
        // }, 'contour-label');

        // map.addLayer({
        //   id: 'wria-text-layer',
        //   type: 'symbol',
        //   source: 'wrias',
        //   'source-layer': 'Upper_Yakima_Basin-c43ed1',
        //   'layout': {
        //     'text-field': [
        //       "to-string",
        //       ["get", "WRIA_NM"]
        //     ],
        //     'text-font': ['Recoleta Regular'],
        //   },
        //   'paint': {
        //     'text-color': '#1A2B3A',
        //     'text-opacity': [
        //       'case',
        //       ['boolean', ['feature-state', 'hover'], false],
        //       1,
        //       0,
        //     ],
        //   }
        // });

        // When a click event occurs on a feature in the states layer, open a popup at the
        // location of the click, with description HTML from its properties.
        map.on('click', 'wria-fill-layer', function (e) {
          //console.log(e.features);
          wria_popup = new mapboxgl.Popup({
            className: 'watershed-popup',
          })
          .setLngLat(e.lngLat)
          .setHTML("<h6 class='mb-0 font-weight-semibold pr-4'>" + e.features[0].properties['WRIA_NM'] + " Watershed</h6>")
          .addTo(map);
        });

        // map.on('click', 'wr-fill-layer', function(e){
        //   // selected_point = e.lngLat;
        //   var feature = e.features[0];
        //   console.log(feature);
        //   outdoor_mitigation_avail = feature.properties['AVAILABLE'] == 'Y';
        //   mitigation_avail = true;
        // });

        // map.on('click', 'parcel-layer', function(e){
        //   // selected_point = e.lngLat;
        //   console.log('parcel selected');
        //   var feature = e.features[0];
        //   console.log(feature);
        // });

        map.on('click', function(e){
          set_selected_point(map, e.lngLat);
        });

        $('#mitigation-search-form').on('submit', function(e){
          e.preventDefault();
          var form = $(this);
          // var search = form.find('input[name="address"]').val();
          var parcel_num = form.find('input[name="parcel_num"]').val();
          if(parcel_num){
            searchParcelNumber(parcel_num, map);
          }
          // } else if(search){
          //   geocodeSearchAddress(search, map);
          // }
        });

        

        

        // Change the cursor to a pointer when the mouse is over the states layer.
        // map.on('mouseenter', 'wria-fill-layer', function () {
        //   map.getCanvas().style.cursor = 'pointer';
        // });

        // When the user moves their mouse over the state-fill layer, we'll update the
        // feature state for the feature under the mouse.
        // map.on('mousemove', 'wria-fill-layer', function (e) {
        //   if (e.features.length > 0) {
        //     if (hoveredWRIA) {
        //       map.setFeatureState(
        //         { source: 'wrias', sourceLayer: 'Upper_Yakima_Basin-c43ed1', id: hoveredWRIA },
        //         { hover: false }
        //       );
        //     }
        //       hoveredWRIA = e.features[0].id;
        //       map.setFeatureState(
        //         { source: 'wrias', sourceLayer: 'Upper_Yakima_Basin-c43ed1', id: hoveredWRIA },
        //         { hover: true }
        //       );
        //     }
        //   });
          
        // When the mouse leaves the state-fill layer, update the feature state of the
        // previously hovered feature.
        // map.on('mouseleave', 'wria-fill-layer', function () {
        //   map.getCanvas().style.cursor = '';
        //   if (hoveredWRIA) {
        //     map.setFeatureState(
        //       { source: 'wrias', sourceLayer: 'Upper_Yakima_Basin-c43ed1', id: hoveredWRIA },
        //       { hover: false }
        //     );
        //   }
        //   hoveredWRIA = null;
        // });
      });
    }
  });

  function check_mitigation_available(map){
    console.log('checking mitigation options...');
    if(!selected_point) { return; }
    var point = map.project(selected_point);
    // set bbox as 2px rectangle area around clicked point
    var bbox = [
      [point.x , point.y],
      [point.x , point.y]
    ];
    mitigation_avail = false;
    outdoor_mitigation_avail = false;

    var wr_features = map.queryRenderedFeatures(bbox, {
      layers: ['wr-fill-layer']
    });
    if(wr_features.length){
      var feature = wr_features[0];
      mitigation_avail = true;
      outdoor_mitigation_avail = feature.properties['AVAILABLE'] == 'Y';
      console.log('mitigation is available');
      if(outdoor_mitigation_avail){
        console.log('outdoor mitigation is available');
      } else {
        console.log('outdoor mitigation is not available');
      }
    }
    var parcel_features = map.queryRenderedFeatures(bbox, {
      layers: ['parcel-layer']
    });
    if(parcel_features.length){
      console.log(parcel_features.length + ' parcels found');
      parcel = parcel_features[0].properties;
      console.log(parcel);
    }
    show_point_results();
  }

  function geocodeAddress(address, map){
    var api_url = geocode_api_url + encodeURI(address) + '.json?limit=1&access_token=' + mapboxgl.accessToken;
    // Get the latitude and longitude via geocoding
    $.get(api_url, function(response){
      if(response.features.length){
        var coord = response.features[0].geometry.coordinates;
        addMarker(coord, map, {
          newCenter: true, 
          offset: [-200, 0],
        });
      }
    });
  }

  function geocodeSearchAddress(address, map){
    var api_url = geocode_api_url + encodeURI(address) + '.json?proximity='+ map_center[0] + ',' + map_center[1] + '&limit=1&access_token=' + mapboxgl.accessToken;
    // Get the latitude and longitude via geocoding
    $.get(api_url, function(response){
      if(response.features.length){
        var coord = response.features[0].geometry.coordinates;
        set_selected_point(map, {lng: coord[0], lat: coord[1]});
      }
    });
  }

  function searchParcelNumber(parcel_num, map){
    var api_url = '/wp-json/dwe/v1/parcels?parcel=' + encodeURI(parcel_num);
    // Get the latitude and longitude via geocoding
    $.get(api_url, function(response){
      if(response.features.length){
        var coord = response.features[0].geometry.coordinates;
        set_selected_point(map, {lng: coord[0], lat: coord[1]}, 14);
      }
    });
  }

  function geocodePoint(lng, lat){
    var api_url = geocode_api_url + lng + ',' + lat + '.json?limit=1&access_token=' + mapboxgl.accessToken;
    return $.get(api_url, function(response){
      if(response.features.length){
        var feature = response.features[0];
        selected_address = feature.place_name;
      }
    });
  }

  function set_selected_point(map, lngLat, zoom){
    console.log('selecting point:' + lngLat);
    selected_point = lngLat;
    // center the map on the point
    if(zoom){
      map.easeTo({center: lngLat, zoom: zoom});
    } else {
      map.easeTo({center: lngLat});
    }
    if(!marker){
      var marker_class = 'marker css-map-marker';
      var marker_el = $('<div>', {class: marker_class});
      marker_el.append(small_marker);
      marker = new mapboxgl.Marker({
        element: marker_el.get(0),
        anchor: 'bottom',
      }).setLngLat(lngLat).addTo(map);
    } else {
      marker.setLngLat(lngLat);
    }
    check_mitigation_available(map)
    // geocodePoint(lngLat.lng, lngLat.lat).then(function(){
      // check_mitigation_available(map);
    // });
  }

  function show_point_results(){
    console.log('showing point results...');
    // change the url of the application link to pass through data
    var url_params = {}
    var content = mitigation_content['unselected'];
    $('#mitigation-button').hide();
    if(selected_point){
      location_text = 'Showing results for: <br/> ';
      if(selected_address){
        location_text += selected_address;
      }
      if(parcel){
        if(selected_address){
          location_text += '<br/><br/>';
        }
        location_text += 'Parcel #' + parcel['PNUM'];

        url_params['parcel'] = parcel['PNUM'];
        url_params['water_group'] = parcel['PWS_GROUP'];
        url_params['water_system'] = parcel['PWSID'];
        url_params['irrigation'] = parcel['IRRIG'];
        url_params['in_water_group'] = '2';
        url_params['in_irrigation'] = '2';
        if(url_params['water_group'].length){
          url_params['in_water_group'] = '1';
        }
        if(url_params['irrigation'].length){
          url_params['in_irrigation'] = '1';
        }
      }
      $('#selected-location').html(location_text);
      if(mitigation_avail){
        url_params['inside_area'] = '1'; // Yes
        if(outdoor_mitigation_avail){
          content = mitigation_content['available'];
          url_params['green_zone'] = '1'; // Yes
        } else {
          content = mitigation_content['available_no_outdoor'];
          url_params['green_zone'] = '2'; // No
        }
        $('#mitigation-button').show();
      } else {
        url_params['inside_area'] = '2'; // No
        content = mitigation_content['unavailable'];
      }
    }
    $('#mitigation-content').html(content);
    $('#mitigation-button').attr('href', update_parameters($('#mitigation-button').attr('href'), url_params));
  }

  /*
  Add a marker to a map.

  @param coord - coordinates of the marker, an array of floats in [lng, lat]
  @param map - mapbox map instance
  @param options - javascript object
  {
    newCenter: false, // make this marker the new center of the map
    offset: false, // to offset the map, pass in a point array to offset the map by [x, y] px
    cssClass: '', // add an additional css class to the marker
    attributes: {}, // key value pairs of data attributes to add to the marker
    popup: '', // add a popup to the marker. string is the html to inject into the popup
  }
  */
  function addMarker(coord, map, options ){
    marker_class = 'marker css-map-marker';
    if('cssClass' in options){
      marker_class += ' ' + options.cssClass;
    }
    var marker_el = $('<div>', {class: marker_class});
    if('size' in options && options.size == 'small'){
      marker_el.append(small_marker);
    } else {
      marker_el.append(marker_svg);
    }
    if('attributes' in options){
      for(var att in options.attributes){
        marker_el.attr('data-' + att, options.attributes[att]); 
      }
    }
    marker_el.on('click', setActiveProject);
    var marker = new mapboxgl.Marker(marker_el.get(0))
      .setLngLat(coord);
    if('popup' in options){
      var marker_html = options['popup'];
      var popup = new mapboxgl.Popup({offset: 25}).setHTML(marker_html);
      popup.on('open', function(e) {
        // console.log('popup open');
        // console.log(e);
        var px = map.project(e.target._lngLat); // find the pixel location on the map where the popup anchor is
        if (window.innerWidth >=400 ){
          px.y += e.target._container.clientHeight/2 // find the height of the popup container, divide by 2, add from the Y axis of marker location
        } else {
          px.y += e.target._container.clientHeight/3 // find the height of the popup container, divide by 2, add from the Y axis of marker location
        }
        map.panTo(map.unproject(px),{animate: true}); // pan to new center
      });
      marker.setPopup(popup);
    }
    marker_el.data('marker', marker);
    marker.addTo(map);
    if('newCenter' in options && options.newCenter){
      map.setCenter(coord);
    }
    if('offset' in options){
      map.panBy(options.offset);
    }
    return marker;
  }

  function update_parameters(url, params){
    console.log(params);
    var res = url;
    $.each(params, function(key, val){
      res = UpdateQueryString(key, encodeURIComponent(val), res);
    });
    console.log(res);
    return res;
  }

  function UpdateQueryString(key, value, url) {
    if (!url) url = window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
        hash;

    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null) {
            return url.replace(re, '$1' + key + "=" + value + '$2$3');
        } 
        else {
            hash = url.split('#');
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        }
    }
    else {
        if (typeof value !== 'undefined' && value !== null) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?';
            hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        }
        else {
            return url;
        }
    }
  }

  function setActiveProject(event){
    event.stopPropagation();
    var marker = $(event.target).parents('.marker');
    if(wria_popup && wria_popup.isOpen()){
      wria_popup.remove();
      wria_popup = null;
    }
    if(marker.data('marker')){
      // remove open popup
      // console.log(active_marker);
      if(active_marker && active_marker.getPopup().isOpen()){
        active_marker.togglePopup();
      }
      // open this popup
      active_marker = marker.data('marker');
      active_marker.togglePopup();
    }
    
    if(marker.data('project-id')){
      $('.project-link').removeClass('active');
      var new_active = $('#project-' + marker.data('project-id'));
      new_active.addClass('active');
      // scroll the project into view
      $('.projects-list').animate({scrollTop: new_active.offset().top});
    }
  }

  function filterProjects(){
    // console.log('filtering projects');
    // console.log(active_project_filters);
    $('.project-link').each(function(){
      var t = $(this);
      if(!t.data('height') && !t.hasClass('filtered')){
        t.data('height', t.height());
      }
      var has_all = filter_elem(t);
      if(has_all){
        t.removeClass('filtered').animate({height: t.data('height'), opacity: 1}, 400);
      } else {
        t.addClass('filtered').animate({height: 0, opacity: 0}, 300);
      }
    });
    $('.css-map-marker').each(function(){
      var t = $(this);
      var has_all = filter_elem(t);
      if(has_all){
        t.removeClass('filtered');
      } else {
        t.addClass('filtered');
      }
    });
  }

  function filter_elem(elem){
    var has_all = true;
    for(filter in active_project_filters){
      var filter_val = active_project_filters[filter];
      if(filter_val){
        if(Array.isArray(filter_val)){
          var has_any = false;
          filter_val.forEach(val => {
            if(elem.data(filter) == val){
              has_any = true;
            }
          });
          has_all = has_any;
        } else {
          if(elem.data(filter) != filter_val){
            has_all = false;
          }
        }
      }
    }
    return has_all;
  }

})(jQuery);